import React from "react";
import ItemHandlingList from "../items/item-handling-list";

/**
 * Work Order-specific wrapper for ItemHandlingList
 * This component uses the generic ItemHandlingList component
 */
const WorkOrderItemHandlingList = ({ itemList, isLoading = false }) => {
  return (
    <ItemHandlingList 
      itemList={itemList} 
      isLoading={isLoading} 
      moduleType="work_order"
    />
  );
};

export default WorkOrderItemHandlingList;

